import { Add, ArrowBack } from '@mui/icons-material'
import { TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { clone } from '../../../features/utils/objClone'
import { useDispatch } from 'react-redux'
import { setAlertMsg } from '../../../redux/reducers/modal/snackBarSlice'
import CountriesInput from '../../../components/form/CountriesInput'
import updateQueueReq from '../../../controllers/settings/queues/updateQueue'
import { queueData } from '../../../data/settings/queue/bankData'
import getSingleQueueReq from '../../../controllers/settings/queues/getSingleQueue'


export default function EditQueue() {
  const [data,setData] = useState(clone(queueData));
  const [loading,setLoading] = useState(false);
  const {id} = useParams();

  useEffect(() => {
    load();
  },[])
  async function load() {
    const res = await getSingleQueueReq(id);
    if(res.return) {
      setData(res.data)
    }
  }

  const dispatch = useDispatch();

  async function handleSubmit() {
        
    let filtered = clone(data);
    filtered = Object.fromEntries(Object.entries(filtered).filter(([key, value]) => value && value !== ""));
    
    setLoading(true);
    const res = await updateQueueReq(filtered,id);
    setLoading(false);
    if(res.return) {
      dispatch(setAlertMsg(['success','Queue Update Successfull.']))
    } else dispatch(setAlertMsg(['error','Failed Updating Queue']))

  }

  return (
    <div className='w-full bg-[#f3f3f3] p-4'>
      <div className='bg-secondary p-4'>
        <Link to="/settings/queues" className='flex gap-4'>
          <ArrowBack />
          <h3>Edit Queue</h3>
        </Link>
        <div className='inline-block py-4'>
          <div className='flex flex-col gap-2 w-auto'>
            <TextField size='small' label='Title'
              value={data.title || ""} onChange={(ev) => setData(data => ({...data,title: ev.target.value}))} 
            />
            <TextField size='small' label='Queue Number' type='number'
              value={data.queueNumber || ""} onChange={(ev) => setData(data => ({...data,queueNumber: ev.target.value}))} 
            />
            <TextField size='small' label='Category' type='number'
              value={data.category || ""} onChange={(ev) => setData(data => ({...data,category: ev.target.value}))} 
            />
            <button className='btn2 flex gap-2' onClick={handleSubmit}>
              {loading?<div className='load'></div>:null}
              Save Queue</button>
          </div>
        </div>
      </div>
    </div>
  )
}
